import { render, staticRenderFns } from "./auto-logic-icon.vue?vue&type=template&id=6090de52&"
import script from "./auto-logic-icon.vue?vue&type=script&lang=js&"
export * from "./auto-logic-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports